import { TimeZone } from '@dokucoach/common-types';
import { DateTime } from 'luxon';

export function startOfDay(date: Date): Date {
  return startOfDayAsDateTime(date).toJSDate();
}

export function startOfDayAsDateTime(date: Date | DateTime): DateTime {
  const inputDate =
    date instanceof DateTime ? date : DateTime.fromJSDate(date, { zone: TimeZone.EUROPE_BERLIN });
  return inputDate.startOf('day');
}

export function endOfDay(date: Date): Date {
  return endOfDayAsDateTime(date).toJSDate();
}

export function endOfDayAsDateTime(date: Date | DateTime): DateTime {
  const inputDate =
    date instanceof DateTime ? date : DateTime.fromJSDate(date, { zone: TimeZone.EUROPE_BERLIN });
  return inputDate.endOf('day');
}

export function startOfMonth(date: Date): Date {
  return startOfMonthAsDateTime(date).toJSDate();
}

export function startOfMonthAsDateTime(date: Date | DateTime): DateTime {
  const inputDate =
    date instanceof DateTime ? date : DateTime.fromJSDate(date, { zone: TimeZone.EUROPE_BERLIN });
  return inputDate.startOf('month');
}

export function endOfMonth(date: Date): Date {
  return endOfMonthAsDateTime(date).toJSDate();
}

export function endOfMonthAsDateTime(date: Date | DateTime): DateTime {
  const inputDate =
    date instanceof DateTime ? date : DateTime.fromJSDate(date, { zone: TimeZone.EUROPE_BERLIN });
  return inputDate.endOf('month');
}

export function toDateTime(date: Date): DateTime {
  return DateTime.fromJSDate(date, { zone: TimeZone.EUROPE_BERLIN });
}

export function isoToDateTime(isoString: string): DateTime {
  return DateTime.fromISO(isoString, { zone: TimeZone.EUROPE_BERLIN });
}

export function dayAfter(date: Date): Date {
  return DateTime.fromJSDate(date).plus({ day: 1 }).toJSDate();
}

export function dayBefore(date: Date): Date {
  return DateTime.fromJSDate(date).minus({ day: 1 }).toJSDate();
}

export function isFullMonth(start: DateTime, end: DateTime): boolean {
  const startOfMonth = start.startOf('month');
  const endOfMonth = end.endOf('month');
  return start.equals(startOfMonth) && end.equals(endOfMonth);
}
